document.addEventListener("DOMContentLoaded", function () {
  const decreaseButtons = document.querySelectorAll(".js-decrease-quantity");
  const increaseButtons = document.querySelectorAll(".js-increase-quantity");
  const removeItemButtons = document.querySelectorAll(".js-remove");

  const productsPrice = document.querySelectorAll(".products-price");
  const finalPrice = document.querySelectorAll(".final-price");

  const observer = new IntersectionObserver(
    ([e]) => e.target.toggleAttribute("data-stuck", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  observer.observe(document.querySelector(".summary__final--mobile"));

  const updateCart = (data) => {
    const items = data.items;
    const cartTotal = data.total_price;
    const rows = document.querySelectorAll(".item-row--desktop");
    const rowsMobile = document.querySelectorAll(".item-row--mobile");
    for (let i = 0; i < rows.length; i++) {
      const rowId = rows[i].dataset.id;
      const item = items.find((item) => item.id == rowId);
      if (item) {
        rows[i].querySelector(".item-total").textContent = `$${parseFloat(
          item.final_line_price * 0.01
        ).toFixed(2)}`;
        rows[i].querySelector(".item-quantity").value = item.quantity;
        rowsMobile[i].querySelector(".item-total").textContent = `$${parseFloat(
          item.final_line_price * 0.01
        ).toFixed(2)}`;
        rowsMobile[i].querySelector(".item-quantity").value = item.quantity;
      } else {
        rows[i].remove();
        rowsMobile[i].remove();
      }
    }

    productsPrice.forEach(
      (price) =>
        (price.textContent = `$${parseFloat(cartTotal * 0.01).toFixed(2)}`)
    );
    finalPrice.forEach(
      (final) =>
        (final.textContent = `$${parseFloat(cartTotal * 0.01).toFixed(2)}`)
    );
  };

  const updateQuantity = (id, quantity) => {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        updateCart(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  decreaseButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const input = button.nextElementSibling;
      let value = parseInt(input.value);
      if (value > 1) {
        value--;

        updateQuantity(button.dataset.id, value);
      }
    });
  });

  increaseButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const input = button.previousElementSibling;
      let value = parseInt(input.value);
      value++;
      updateQuantity(button.dataset.id, value);
    });
  });

  removeItemButtons.forEach((button) => {
    button.addEventListener("click", function () {
      updateQuantity(button.dataset.id, 0);
    });
  });
});
